import { teadsApi } from './teads-api';

interface TrackingParams {
  sid?: number;
  gid?: number;
  cid?: number;
  pid?: number;
  auctid?: string;

  env?: string;
  slot?: string;
}

const trackingParams = {} as TrackingParams;

export function initTracking() {
  teadsApi.getContextData((err, response) => {
    if (err) return console.error(err);
    const { tracking, context } = response;
    trackingParams.sid ??= tracking?.sid;
    trackingParams.gid ??= tracking?.gid;
    trackingParams.cid ??= tracking?.cid;
    trackingParams.pid ??= tracking?.pid;
    trackingParams.auctid ??= tracking?.auctid;
    trackingParams.env ??= context?.format?.env;
    trackingParams.slot ??= context?.format?.slot;
  });
  teadsApi.getTeadsInfo((err, teadsInfo) => {
    if (err) return console.error(err);
    trackingParams.sid ??= teadsInfo?.connectionId;
    trackingParams.gid ??= teadsInfo?.insertionId;
    trackingParams.cid ??= teadsInfo?.creativeId;
    trackingParams.pid ??= teadsInfo?.placementId;
    trackingParams.env ??= teadsInfo?.environment;
    trackingParams.slot ??= teadsInfo?.slotType;
  });
}

declare const AD_TRACKING_IMPRESSION: string[];

export function trackImpressionForBanner() {
  if (typeof AD_TRACKING_IMPRESSION != 'undefined') {
    for (const trackingUrl of AD_TRACKING_IMPRESSION) {
      trackPixel(trackingUrl);
    }
  }
}

export function trackPixel(tracking: string) {
  const img = new Image();
  img.src = tracking;
}

export function getTrackingParams() {
  return trackingParams;
}

export function track(action: string) {
  const url = new URL('https://studio-t.teads.tv/track');
  url.searchParams.set('action', action);
  url.searchParams.set('ts', Date.now().toString());
  const params = getTrackingParams();
  (Object.keys(params) as (keyof TrackingParams)[])
    .filter((key) => !!params[key])
    .map((key) => url.searchParams.set(key, params[key]!.toString()));

  trackPixel(url.toString());
}
